// Copyright (c) Meta Platforms, Inc. and affiliates.
// All rights reserved.

// This source code is licensed under the license found in the
// LICENSE file in the root directory of this source tree.

import { InsHTMLAttributes, createContext } from "react";
import { modelInputProps } from "../helpers/Interfaces";

type ThingmojiItem = {
  resizedImage: HTMLImageElement,
  originalImage: HTMLImageElement
};

type imageItem = {
    image: string,
    originalImage: string,
    index: number
}

type messageItem = {
  texts: string[],
  images: imageItem[] ,
  index: number
}

interface contextProps {
  clicks: [
    clicks: modelInputProps[] | null,
    setClicks: (e: modelInputProps[] | null) => void
  ];
  selected: [
    selected: modelInputProps[] | null,
    setSelected: (e: modelInputProps[] | null) => void
  ];
  image: [
    image: HTMLImageElement | null,
    setImage: (e: HTMLImageElement | null) => void
  ];
  maskImg: [
    maskImg: HTMLImageElement | null,
    setMaskImg: (e: HTMLImageElement | null) => void
  ];
  segmentedImage: [
    segmentedImage: HTMLImageElement | null,
    setSegmentedImage: (e: HTMLImageElement | null) => void
  ];
  isBrushing: [
    isBrushing: boolean,
    setIsBrushing: (e: boolean) => void
  ],
  allThingmoji: [
    allThingmoji: ThingmojiItem[] | null,
    setAllThingmoji: (e: ThingmojiItem[] | null) => void
  ],
  //add message and setMessage as a dictionary, with texts, images, and index
  message: [
    message: messageItem | null,
    setMessage: (e: messageItem | null) => void
  ],
  thingmoji: [
    thingmoji: ThingmojiItem | null,
    setThingmoji: (e: ThingmojiItem | null) => void
  ],

  //set interval as a reference rather than a state, not constant
  intervalthingmoji: any | null

}

const AppContext = createContext<contextProps | null>(null);

export default AppContext;
